import Component from '@cell/cell-core/component/component';
import './quantity-selector.scss';

class QuantitySelector extends Component {
  constructor() {
    super();

    this.quantity = this.parsedDataset.quantity;

    this.handleDecrement = this.handleDecrement.bind(this);
    this.handleIncrement = this.handleIncrement.bind(this);
    this.handleManualInput = this.handleManualInput.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.decrement-quantity', this.handleDecrement);

    this.on('c-button.click.increment-quantity', this.handleIncrement);

    this.on('c-input.change', this.handleManualInput);
  }

  handleDecrement() {
    const previousQuantity = this.quantity;

    this.quantity--;

    this.emit('update', {
      quantity: this.quantity,
      previousQuantity,
    });
  }

  handleIncrement() {
    const previousQuantity = this.quantity;

    this.quantity++;

    this.emit('update', {
      quantity: this.quantity,
      previousQuantity,
    });
  }

  handleManualInput(event) {
    const previousQuantity = this.quantity;

    this.quantity = event.data.value;

    this.emit('update', {
      quantity: this.quantity,
      previousQuantity,
    });
  }
}

customElements.define('quantity-selector', QuantitySelector);
